import { useState } from 'react';
import { useParams } from 'react-router';
import { connect, ConnectedProps } from 'react-redux';
import { Accordion, Column, Heading, Spacer, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { FeatureFlagsComponent, FeatureFlags } from '@oliasoft/feature-flags';

import { selectCompanyNameById } from 'store/entities/companies/selectors';
import { updateFeatureFlag } from 'store/entities/feature-flags/feature-flags';
import { selectSubjectId } from 'store/entities/authorization/selectors';
import type { TRootState } from 'store/store-types';

const FeatureFlagList = ({ updateFeatureFlag, subjectid, customerName }: IFeatureFlagProp) => {
  const [flags, setFlags] = useState(FeatureFlags.getFlags());

  const { company } = useParams();
  const companyName = customerName(company!);

  const onChange = (state: boolean, featureFlagId: string, featureFlagName: string) => {
    updateFeatureFlag({ featureFlagId, state, customerName: companyName });
    FeatureFlags.setFlag(featureFlagName, state, subjectid);
    setFlags(FeatureFlags.getFlags());
  };

  return (
    <Column>
      <Spacer height="var(--padding-sm)" />
      <Accordion expanded heading={<Heading>Feature flags</Heading>} managed bordered padding={false}>
        <FeatureFlagsComponent featureFlags={flags} customerName={companyName} onChange={onChange} />
      </Accordion>
    </Column>
  );
};

const mapDispatchToProps = {
  updateFeatureFlag,
};

const mapStateToProps = ({ entities }: TRootState) => ({
  subjectid: selectSubjectId(entities),
  customerName: (companyId: string) => selectCompanyNameById(entities, companyId),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type IFeatureFlagProp = ConnectedProps<typeof connector>;

export default withErrorBoundary(connector(FeatureFlagList));
